export default function RoadmapSection() {
  return <section className="py-20"><div className="text-center text-white">Roadmap</div></section>;
}
